import React, { useState } from 'react';
import { Box, Button, TextField, Dialog, MenuItem, Grid, FormControlLabel, Switch, } from '@mui/material';

const EditVendorStreamDialog = ({ initialData, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    name: initialData.name || '',
    serverPath: initialData.serverPath || '',
    url: initialData.url || '',
    serverType: initialData.serverType || '',
    vendorId: initialData.vendorId || '',
    channelPort: initialData.channelPort || '',
    streamEngine: initialData.streamEngine || 'OTHER',
    //galleryPort: initialData.galleryPort || '',
    //galleryUploadPort: initialData.galleryUploadPort || '',
    apiPort: initialData.apiPort || '',
    channelsCount: initialData.channelsCount || 0,
    mediaServerUrl: initialData.mediaServerUrl || '',
    mediaServerChannelPort: initialData.mediaServerChannelPort || '',
    publicUrl: initialData.publicUrl || '',
    publicChannelPort: initialData.publicChannelPort || '',
    keyStorePath: initialData.keyStorePath || '',
    serverUserName: initialData.serverUserName || '',
    serverPassword: initialData.serverPassword || '',
    priority: initialData.priority || '1',
    serverRole: initialData.serverRole || 'MAIN',
    isActive: initialData.isActive === true || initialData.isActive === "true"
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSwitchChange = (e) => {
    console.log("Switch:", e.target.checked);

    setFormData(prev => ({
        ...prev,
        isActive: e.target.checked
    }));
};

  const TYPE_OPTIONS = [
  { label: 'DRM', value: 'DRM' },
  { label: 'CRM', value: 'CRM' },
  { label: 'STREAM', value: 'STREAM' },
  { label: 'Media Server', value: 'MEDIA_SERVER' },
  { label: 'Backup Server', value: 'BACKUP_SERVER' },
  { label: 'Others', value: 'OTHER' },
];


  const handleSubmit = (e) => {
      e.preventDefault();

      console.log("Submitting:", formData);

      onSubmit({
          ...initialData,
          ...formData
      });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextField fullWidth margin="normal" label="Name" name="name" value={formData.name} onChange={handleChange} />
        </Grid>
        <Grid item xs={4}>
          <TextField fullWidth margin="normal" label="Server Path" name="serverPath" value={formData.serverPath} onChange={handleChange} />
        </Grid>
        <Grid item xs={4}>
          <TextField fullWidth margin="normal" label="URL" name="url" value={formData.url} onChange={handleChange} />
        </Grid>
        <Grid item xs={4}>
           <TextField
  select
  fullWidth
  margin="normal"
  label="Priority"
  name="priority"
  value={formData.priority}
  onChange={handleChange}
>
  <MenuItem value="1">1</MenuItem>
  <MenuItem value="2">2</MenuItem>
</TextField>
        </Grid>
        <Grid item xs={4}>
          <TextField
  select
fullWidth
  margin="normal"
  label="Server Role"
  name="serverRole"
  value={formData.serverRole}
  onChange={handleChange}
>
  <MenuItem value="MAIN">Main</MenuItem>
  <MenuItem value="BACKUP">Backup</MenuItem>
</TextField>
        </Grid>

        <Grid item xs={4}>
           <TextField
              select
              fullWidth
              label="streamEngine"
              name="streamEngine"
              value={formData.streamEngine}
              onChange={handleChange}
              //SelectProps={{ native: true }}
            >
              
              <MenuItem value="OTHER">OTHER</MenuItem>
              <MenuItem value="WOWZA">WOWZA</MenuItem>
              <MenuItem value="HLS">HLS</MenuItem>
              <MenuItem value="HLS_EXTERNAL">HLS_EXTERNAL</MenuItem>
            </TextField>
        </Grid>

        <Grid item xs={4}>
          <TextField
  select

  margin="normal"
  label="Server Type"
  name="servertype"
  fullWidth
  value={formData.serverType}
  onChange={handleChange}
>
  {TYPE_OPTIONS.map((type) => (
    <MenuItem key={type.value} value={type.value}>
      {type.label}
    </MenuItem>
  ))}
</TextField>
        </Grid>

         {/* <TextField margin="normal" label="Vendor ID" name="vendorId" value={formData.vendorId} onChange={handleChange} /> */}
      <Grid item xs={4}>
<TextField fullWidth margin="normal" label="Channel Port" name="channelPort" value={formData.channelPort} onChange={handleChange} />
      </Grid>
      {/* <TextField margin="normal" label="Gallery Port" name="galleryPort" value={formData.galleryPort} onChange={handleChange} />
      <TextField margin="normal" label="Gallery Upload Port" name="galleryUploadPort" value={formData.galleryUploadPort} onChange={handleChange} /> */}
      <Grid item xs={4}>
      <TextField fullWidth margin="normal" label="API Port" name="apiPort" value={formData.apiPort} onChange={handleChange} />
      </Grid>
      
      <Grid item xs={4}>
      <TextField fullWidth margin="normal" label="Channels Count" name="channelsCount" value={formData.channelsCount} onChange={handleChange} />
      </Grid>

       <Grid item xs={4}>
        <TextField fullWidth margin="normal" label="Media Server URL" name="mediaServerUrl" value={formData.mediaServerUrl} onChange={handleChange} />
       </Grid>

       <Grid item xs={4}>
        <TextField fullWidth margin="normal" label="Media Server Channel Port" name="mediaServerChannelPort" value={formData.mediaServerChannelPort} onChange={handleChange} />
       </Grid>
      
      <Grid item xs={4}><TextField fullWidth margin="normal" label="Public URL" name="publicUrl" value={formData.publicUrl} onChange={handleChange} /></Grid>
      <Grid item xs={4}><TextField fullWidth margin="normal" label="Public Channel Port" name="publicChannelPort" value={formData.publicChannelPort} onChange={handleChange} /></Grid>
      <Grid item xs={4}><TextField fullWidth margin="normal" label="Key Store Path" name="keyStorePath" value={formData.keyStorePath} onChange={handleChange} /></Grid>
      <Grid item xs={4}><TextField fullWidth margin="normal" label="Server Username" name="serverUserName" value={formData.serverUserName} onChange={handleChange} /></Grid>
      <Grid item xs={4}><TextField fullWidth margin="normal" label="Server Password" name="serverPassword" value={formData.serverPassword} onChange={handleChange} /></Grid>
      
      
      

        
      </Grid>
      
      
      


          


           
       
     
      
      

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      
        <Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 2
  }}
>
  <FormControlLabel
    control={
      <Switch
        checked={formData.isActive}
        onChange={handleSwitchChange}
        color="primary"
      />
    }
    label="Is Active"
  />

  <Box sx={{ display: 'flex', gap: 2 }}>
    <Button onClick={onClose} variant="outlined">
      Cancel
    </Button>
    <Button type="submit" variant="contained" color="primary">
      Save
    </Button>
  </Box>
</Box>
      </Box>
    </Box>
  );
};

export default EditVendorStreamDialog;
